import axiosInstance from "./axiosInstance";

export interface AgeRuleApi {
  ageRuleId: number;
  categoryName: string;
  minAge: number;
  maxAge: number;
  moduleId: number;
  calculationMethod: string;
  effectiveFrom: string;
  effectiveTo: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string | null;
}

export interface AgeRuleListResponse {
  items: AgeRuleApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface AgeRuleListQuery {
  searchText?: string | null;
  categoryName?: string | null;
  moduleId?: number | null;
  calculationMethod?: string | null;
  fromAge?: number | null;
  toAge?: number | null;
  isActive?: boolean | null;
  pageNo?: number;
  pageSize?: number;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAgeRules = async (
  params: AgeRuleListQuery
): Promise<AgeRuleListResponse> => {
  const res = await axiosInstance.get("/AgeRule/list", { 
    params,
    headers: getAuthHeader(), 
  });
  return res.data;
};

export interface CreateAgeRulePayload {
  categoryName: string;
  minAge: number;
  maxAge: number;
  moduleId: number;
  calculationMethod: string;
  effectiveFrom: string;
  effectiveTo?: string | null;
  isActive: boolean;
  createdBy: number;
}

export const createAgeRule = async (payload: CreateAgeRulePayload) => {
  const res = await axiosInstance.post("/AgeRule", payload, {
     headers: getAuthHeader(),
  });
  return res.data;
};

export interface UpdateAgeRulePayload {
  ageRuleId: number;
  categoryName: string;
  minAge: number;
  maxAge: number;
  moduleId: number;
  calculationMethod: string;
  effectiveFrom: string;
  effectiveTo?: string | null;
  isActive: boolean;
  updatedBy: number;
}

export const updateAgeRule = async (payload: UpdateAgeRulePayload) => {
  const res = await axiosInstance.put(
    `/AgeRule/${payload.ageRuleId}`,
    payload, {
       headers: getAuthHeader(),
    }
  );
  return res.data;
};
